import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { formatDomainAge } from 'dashboard/components/ChecksTable/computeCheckMetadata/businessWebsiteDomainAgeDetection';
import { BusinessWebsiteDomainExpirationDetection } from 'dashboard/models/check';

export const computeBusinessWebsiteDomainExpirationDetectionMetadata = (
  check: BusinessWebsiteDomainExpirationDetection,
): CheckMetadata => {
  const expiresAt = check.metadata?.['expires-at'];
  const expiresInDays = check.metadata?.['expires-in-days'];
  const metadata = [
    {
      label: 'Expires At',
      value: expiresAt ? expiresAt : '-',
    },
  ];

  if (expiresInDays != null) {
    metadata.unshift({
      label: 'Expires In',
      value: expiresInDays ? formatDomainAge(expiresInDays) : '-',
    });
  }
  return {
    metadata: createSimpleCheckMetadataArray(metadata),
    hideIfVerificationPassed: false,
  };
};
